<div class="assignment-edit-dialog">
  <div class="dialog-header">
    <h2 class="dialog-title">Assignment Details</h2>
    <button mat-icon-button disableRipple (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="request-summary">
      <div class="employee-row">
        <div class="employee-name">
          {{ resourceName }}
          @if (clientMatterNumber) {
            <app-copyable-text
              variant="chip"
              [value]="clientMatterNumber"
              [displayText]="'#' + clientMatterNumber"
              copyTitle="Click to copy matter ID"
            />
          }
        </div>
        @if (currentStatusLabel) {
          <span class="status-badge" [ngClass]="statusBadgeClass">
            {{ currentStatusLabel }}
          </span>
        }
      </div>
      @if (dateRangeLabel) {
        <div class="request-meta">
          <span class="meta-dates">
            <mat-icon class="meta-icon">event</mat-icon>
            <span>{{ dateRangeLabel }}</span>
            @if (weeksLabel) {
              <span class="meta-days">({{ weeksLabel }})</span>
            }
          </span>
        </div>
      }
    </div>
    <form [formGroup]="form" class="edit-form">
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status">
            @for (opt of statusOptions; track opt.value) {
              <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Assignment Type</mat-label>
          <mat-select formControlName="assignmentTypeCategory">
            @for (opt of typeOptions; track opt.value) {
              <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Start Date</mat-label>
          <input
            matInput
            [matDatepicker]="startPicker"
            formControlName="startDate"
            aria-label="Start date"
            placeholder="MM/DD/YYYY"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="startPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>End Date</mat-label>
          <input
            matInput
            [matDatepicker]="endPicker"
            [min]="minEndDate"
            formControlName="endDate"
            aria-label="End date"
            placeholder="MM/DD/YYYY"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="endPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
      </div>

      @if (blockingDateError) {
        <div class="form-error">End date must be after start date.</div>
      }

      @if (showTaskSection) {
        <section class="note-section task-section">
          <h3 class="note-section-title">Tasks</h3>
          <!-- Read-only: the same list the card's expanded row shows. Removing a task
               is not in v1, so nothing here is editable — tasks are only added. -->
          @if (isLoadingTasks) {
            <div class="task-loading">
              <mat-spinner diameter="16"></mat-spinner>
              <span>Loading tasks...</span>
            </div>
          } @else if (showTaskPicker) {
            <app-searchable-multi-select
              class="task-picker"
              label="Add Tasks"
              searchPlaceholder="Search tasks..."
              [emptyOptionsText]="taskPickerEmptyText"
              [options]="taskOptions"
              formControlName="newTaskCodes"
            ></app-searchable-multi-select>
          }
          <app-task-assignment-list [tasks]="taskAssignments" />
        </section>
      }

      @if (data.showManagerNotes !== false) {
        <section class="note-section">
          <h3 class="note-section-title">
            Manager Note
            <span class="note-label-hint"
              >(optional - this note may be restricted for other users due to
              their visibility settings)</span
            >
          </h3>
          <textarea
            class="manager-note-textarea"
            formControlName="notes"
            rows="5"
            [attr.aria-label]="
              data.canEditManagerNotes
                ? 'Manager note about this assignment'
                : 'Manager note about this assignment (read-only)'
            "
            [placeholder]="
              data.canEditManagerNotes
                ? 'Add note for the assignment...'
                : 'No note added.'
            "
          ></textarea>
        </section>
      }

      @if (showResourceNoteSection) {
        <section class="note-section">
          <h3 class="note-section-title">
            @if (data.canEditResourceNotes) {
              My Note
              <span class="note-label-hint">(optional)</span>
            } @else {
              Resource's Note
            }
          </h3>
          <textarea
            class="manager-note-textarea"
            formControlName="resourceNotes"
            rows="5"
            [attr.aria-label]="
              data.canEditResourceNotes
                ? 'My note about this assignment'
                : 'Note from the assigned resource'
            "
            [placeholder]="
              data.canEditResourceNotes
                ? 'Add a note about this assignment...'
                : 'No note added.'
            "
          ></textarea>
          @if (!data.canEditResourceNotes && resourceNoteLastUpdatedName) {
            <div class="note-meta">
              Last updated by {{ resourceNoteLastUpdatedName }}
              @if (resourceNoteLastUpdatedTimestamp) {
                on {{ resourceNoteLastUpdatedTimestamp | date: "MMM d, y" }}
              }
            </div>
          }
        </section>
      }
    </form>
  </mat-dialog-content>

  <div class="dialog-actions">
    <span class="actions-spacer"></span>
    @if (data.canEdit || data.canEditResourceNotes) {
      <button
        mat-raised-button
        class="save-button"
        (click)="save()"
        [disabled]="isSaving || blockingDateError || !isDirty"
      >
        @if (isSaving) {
          <mat-spinner diameter="16"></mat-spinner>
        } @else {
          Save Changes
        }
      </button>
    }
  </div>
</div>
